import { useState } from 'react';
import { Link } from 'react-router-dom';

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-amber-600 to-amber-500 text-white py-2">
        <div className="container mx-auto px-4 text-center text-sm font-medium">
          <i className="ri-truck-line mr-2"></i>
          Ücretsiz Sigortalı Kargo - Güvenli Alışveriş
        </div>
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-vip-crown-fill text-4xl text-amber-600"></i>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Emin
              </span>
              <span className="text-sm font-medium text-amber-600 -mt-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Kuyumculuk
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
              Anasayfa
            </Link>
            
            <Link to="/kategori" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
              Ürünler
            </Link>

            <Link to="/hakkimizda" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
              Hakkımızda
            </Link>
            <Link to="/sss" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
              SSS
            </Link>
            <Link to="/iletisim" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
              İletişim
            </Link>
          </nav>

          {/* Right Icons */}
          <div className="flex items-center space-x-6">
            <Link to="/hesap" className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer">
              <i className="ri-user-line text-2xl"></i>
            </Link>
            <Link to="/hesap" className="text-gray-700 hover:text-amber-600 transition-colors relative cursor-pointer">
              <i className="ri-heart-line text-2xl"></i>
              <span className="absolute -top-2 -right-2 bg-amber-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                0
              </span>
            </Link>
            <Link to="/sepet" className="text-gray-700 hover:text-amber-600 transition-colors relative cursor-pointer">
              <i className="ri-shopping-cart-line text-2xl"></i>
              <span className="absolute -top-2 -right-2 bg-amber-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                0
              </span>
            </Link>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-gray-700 hover:text-amber-600 transition-colors cursor-pointer"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
                Anasayfa
              </Link>
              <Link to="/kategori" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
                Ürünler
              </Link>
              <Link to="/hakkimizda" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
                Hakkımızda
              </Link>
              <Link to="/sss" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
                SSS
              </Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-amber-600 font-medium transition-colors cursor-pointer">
                İletişim
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
